import { useEffect, useState } from "react";
import { toast } from "sonner";
import { UserProfile } from "@clerk/react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { errMsg } from "@/lib/api";
import { useClerkAvailable } from "@/components/auth/ClerkAuthProvider";
import { useLocalAuth } from "@/components/auth/LocalAuth";
import { usePanel } from "./PanelContext";

export default function Account() {
  const { api, biz, reload, me } = usePanel();
  const clerkAvailable = useClerkAvailable();
  const { user: localUser, logout } = useLocalAuth();
  const [f, setF] = useState({ name: biz.name, phone: biz.phone, address: biz.address });
  useEffect(() => { setF({ name: biz.name, phone: biz.phone, address: biz.address }); }, [biz]);
  const save = async () => {
    try { await api.put("/business", f); await reload(); toast.success("İşletme bilgileri kaydedildi"); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="space-y-6 rise" data-testid="account-page">
      <div><h1 className="text-3xl font-extrabold">Hesap Ayarları</h1><p className="text-sm text-slate-500">İşletme bilgilerinizi, e-posta adresinizi ve şifrenizi buradan değiştirin.</p></div>
      <div className="rounded-3xl bg-white border p-6 grid sm:grid-cols-3 gap-4 items-end">
        <div><Label>İşletme adı</Label><Input value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="account-business-name-input" /></div>
        <div><Label>Telefon</Label><Input value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} data-testid="account-business-phone-input" /></div>
        <div><Label>Adres</Label><Input value={f.address} onChange={(e) => setF({ ...f, address: e.target.value })} data-testid="account-business-address-input" /></div>
        <Button className="rounded-full bg-[#FF6B0A] hover:bg-[#E55A00] sm:col-span-3 sm:w-fit" onClick={save} data-testid="account-business-save-btn">Kaydet</Button>
      </div>
      <div>
        <h2 className="font-display text-xl font-bold mb-3">E-posta ve Şifre</h2>
        {localUser ? (
          <div className="rounded-3xl bg-white border p-6 max-w-md" data-testid="account-local-profile">
            <p className="text-sm text-slate-500">Giriş yapan hesap</p>
            <p className="font-semibold mt-1" data-testid="account-user-email">{localUser.email}</p>
            <p className="text-xs text-slate-400 mt-0.5">{me?.user?.role === "admin" ? "Süper Yönetici" : "Üye"}</p>
            <p className="text-sm text-slate-500 mt-4">Şifre değiştirmek için giriş sayfasındaki “Şifremi unuttum” bağlantısını kullanın.</p>
            <Button variant="outline" className="rounded-full mt-4" onClick={logout} data-testid="account-logout-btn">Çıkış Yap</Button>
          </div>
        ) : clerkAvailable ? (
          <>
            <p className="text-sm text-slate-500 mb-4">“Güvenlik” sekmesinden şifrenizi, “Profil” sekmesinden e-posta adresinizi değiştirebilirsiniz.</p>
            <div className="overflow-x-auto" data-testid="account-user-profile"><UserProfile routing="hash" /></div>
          </>
        ) : null}
      </div>
    </div>
  );
}
